module.exports = __webpack_public_path__ + "static/media/questioner-walk.063d3257.gif";